﻿import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { AccountProductService } from './account-product.service'
import { AccountProductListComponent } from './account-product-list/account-product-list.component';
import { AccountProductEditComponent } from './account-product-edit/account-product-edit.component';

@NgModule({
    imports:  [SharedModule] ,
    providers:  [AccountProductService] ,
    declarations:  [AccountProductListComponent, AccountProductEditComponent] ,
    exports:  [AccountProductListComponent, AccountProductEditComponent] ,
    entryComponents:  [AccountProductListComponent, AccountProductEditComponent] 
})
export class AccountProductModule { }